import * as React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
import styled from 'styled-components';
import * as grid from '@helpcenter/styles/src/grid';
import { LoadingContainer } from 'view/common/loading-container';
import { token } from '@atlaskit/tokens';

interface NoteContentProps {
    isLoading: boolean;
    isCentered?: boolean;
    children: React.ReactNode;
}

export class NoteContent extends React.Component<NoteContentProps> {
    render() {
        return (
            <NoteContentContainer isCentered={this.props.isCentered} data-testid="note-content-container">
                <LoadingContainer isLoading={this.props.isLoading} loadingPosition="fill-container">
                    {this.props.children}
                </LoadingContainer>
            </NoteContentContainer>
        );
    }
}

interface NoteContentContainerProps {
    isCentered?: boolean;
}

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const NoteContentContainer = styled.div<NoteContentContainerProps>`
    margin: ${token('space.800', '64px')};
    max-width: ${grid.multiple(44).px};
    text-align: ${(props) => (props.isCentered ? 'center' : 'start')};
`;
